// A copy of the fullstack's app/composables/useFitLines.js (2026-10-31; keep the two the same
// until the Frontend is migrated).
// One font size for a set of one-line labels (Seán, 2026-10-31; the posters' speaker lines,
// name and affiliation): the largest size at which the longest of them fits its box on one
// line, capped at the stylesheet's, then applied to every one, so they share a size and a
// height. Proportional, as useFitText.js (one measurement gives the size), after the web fonts
// load and whenever the items change. Each label needs `white-space: nowrap` and reads the
// size from the CSS variable the caller sets (e.g. `font-size: var(--line-size, 1em)`).
import {nextTick, onMounted, ref, watch} from "vue";

export function useFitLines(rootRef, selector, source) {
  const size = ref("");
  async function fit() {
    const root = rootRef.value;
    if (!root) return;
    await document.fonts.ready;
    size.value = ""; // measure at the stylesheet's size
    await nextTick();
    const lines = [...root.querySelectorAll(selector)];
    if (!lines.length) return;
    const ratios = lines.map((line) => line.clientWidth / line.scrollWidth);
    const base = parseFloat(window.getComputedStyle(lines[0]).fontSize);
    const fitted = Math.min(1, ...ratios) * base * 0.995; // a hair under: rounding
    size.value = `${Math.floor(fitted * 10) / 10}px`;
  }
  watch(source, fit, {flush: "post"});
  onMounted(fit);
  return size;
}
